<template>
    <div>
      <header-sales></header-sales>

      <!--pc view -->
      <div v-if="!mobileView">
         <div id= "subheader"> </div>
         <div id= "main-container">
            <div id= "label-container">
              <span id="label">Cuenta Corriente</span>
            </div>
            <div id= "container">
              <div id="listMenu-container">
                <div id="listMenu-containerL">
                  <input id="busqueda" type="text" placeholder="# Comprobante..." v-model="txtBusqueda" v-on:keyup="onKeyDownHandler">
                </div>
                <div id="listMenu-containerR"> </div>
              </div>
              <div id="headerList-container">
                <div id="headerList-comprobante" class="textHeaderList" style="width: 14%">FECHA</div>
                <div id="headerList-tipo" class="textHeaderList" style="width: 14%">TIPO</div>
                <div id="headerList-fecha" class="textHeaderList" style="width: 14%">NRO</div>
                <div id="headerList-vencimiento" class="textHeaderList" style="width: 14%">VENCIMIENTO</div>
                <div id="headerList-monto" class="textHeaderList" style="width: 22%">IMPORTE</div>
                <div id="headerList-saldo" class="textHeaderList" style="width: 22%">SALDO ACUM.</div>
              </div>
              <div  class="separator" style="width: 100%; height: 1px; background-color: #dddddd;" >  </div>
              <div id="list-container">
                <div v-if="filtered.length">
                  <item-cc id="list-prod" v-for="item in filtered" :item='item' @checkItem="itemChecked" ref="itemCC"></item-cc>
                </div>
                <div v-else style="margin-top:30px">
                  Este cliente no posee cuentas corrientes asociadas.
                </div>
              </div>
            </div>
         </div>
      </div> 


      <!--mobile view -->
      <div v-if="mobileView" style="margin-top: 40px">
          <div class="fh cc" style="width: 100vw; height:4vh; background:#44C7F4; color:white; font: size 12px;">Cuenta Corriente</div>
          <div class="fv cc" style="width: 100vw; height: 15vh;">
            <input id="busqueda" style="margin-left: 0; width: 75%"  type="text" placeholder="# Comprobante..." v-model="txtBusqueda" v-on:keyup="onKeyDownHandler">
          </div>
          <div class="fv ct" style="overflow: auto; height: 60vh">
            <item-cc id="list-prod" v-for="item in filtered" :item='item'></item-cc>
          </div>
      </div>   


    </div>
  </template>

<script>
import HeaderSales from "@components/views/header.vue";
import ItemCuentaCorriente from "@components/views/ctacte/item.vue";


export default {
  name: "CuentaCorriente",
  components: {
    "header-sales": HeaderSales,
    "item-cc": ItemCuentaCorriente
  },

  data() {
    return {
      txtBusqueda: "",
      checked: false,
      comprobChecked: [],
      items: [],
      mobileView:false
    };
  },

  computed: {
    filtered () {
      return this.items.filter(c => `${c.Numero}`.indexOf(this.txtBusqueda) !== -1)
    }
  },

  methods: {

    onResize() {
          if (window.innerWidth > 600) 
          {
            this.mobileView=false;
          }
          else 
          {
            this.mobileView=true;
          }
        },

    onKeyDownHandler() {},

    checkAllEvent() {
      if (!this.checked) {
        this.checked = true;
      } else {
        this.checked = false;
      }
      this.$emit("checkAllItems", this.checked);
    },

    itemChecked(id) {
      if (this.comprobChecked.includes(id)) {
        var index = this.comprobChecked.indexOf(id);
        if (index > -1) {
          this.comprobChecked.splice(index, 1);
        }
      } else {
        this.comprobChecked.push(id);
      }
      console.log(">>>" + this.comprobChecked);
    },

    btnDelete() {},

    btnDownload() {}
  },

  mounted() {
    this.$store.commit("loader/stop");
    localStorage.setItem("lastActivity",Math.floor(Date.now() / 1000));
    this.onResize()

    var auxItems = this.$store.state.user.ctaCte.Comprobantes;
    auxItems.sort((a,b) => (new Date(b.FechaAlta) > new Date(a.FechaAlta)) ? 1 : ((new Date(a.FechaAlta) > new Date(b.FechaAlta)) ? -1 : 0)); 
    var auxAcum =  parseFloat(String(this.$store.state.user.ctaCte.SaldoActual).substring(0,6))   
    auxItems.forEach((j) => { 
       var item= {
                Fecha: j.Fecha,
                FechaVencimiento: j.FechaVencimiento,
                Importe: j.Importe,
                Numero: j.Numero,
                Tipo: j.Tipo,
                Acum: auxAcum
       } 
      this.items.push(item)  
      console.log(auxAcum)
      auxAcum = Number(auxAcum) - Number(j.Importe)
    });   
  },

  created() {
     window.addEventListener('resize', this.onResize)
    },

    beforeDestroy() {
     window.removeEventListener('resize', this.onResize)
    }

};
</script>


<style scoped>
#listMenu-container {
  width: 100%;
  height: 60px;
  display: flex;
  flex-direction: row;
  align-items: center;
  background: #ffffff;
}

#listMenu-containerL {
  width: 50%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  background: #ffffff;
}

#busqueda {
  border-radius: 20px;
  width: 150px;
  margin-left: 25px;
  padding-left: 40px;
  height: 20px;
  border-style: solid;
  border: none;
  border-width: 1px;
  border: 1px solid #dddddd;
  color: #000000;
  outline: none;
  background: white url(/dist/icon-search.png) left no-repeat;
  background-size: 15px 15px;
  background-position: 10px;
  font-size: 12px;
  font-family: "Rubik", sans-serif;
}

#listMenu-containerR {
  width: 50%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  background: #ffffff;
}

.textHeaderList {
  color: #656e76;
  font-size: 10px;
  font-weight: 500;
}

#headerList-container {
  width: 650px;
  margin-left: 22px;
  height: 25px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background: #ffffff;
}

.checkContainer {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.icon {
  height: 25px;
  margin-right: 25px;
}

.icon:hover {
  cursor: pointer;
}

#subheader {
  width: 100%;
  height: 35vh;
  background: linear-gradient(#005a9f, #1899d6);
}

#main-container {
  position: absolute;
  top: 55vh;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 700px;
  height: 85vh;
}

#label-container {
  width: 700px;
  height: 10vh;
}

#label {
  color: #ffffff;
  font-size: 27px;
}

#container {
  width: 700px;
  height: 75vh;
  padding-top: 0px;
  border-width: 1px;
  border: 1px solid #dddddd;
  box-sizing: border-box;
  background-color: #ffffff;
}

#list-container {
  width: 680px;
  margin-top: 10px;
  height: 56vh;
  margin-left: auto;
  margin-right: auto;
  background: #ffffff;
  overflow: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* width */
::-webkit-scrollbar {
  width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px #dddddd;
  border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #cccccc;
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #bbbbbb;
}
</style>



// WEBPACK FOOTER //
// src/components/views/ctacte/index.vue